// container
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import CloseBox from '../CloseBox';
import { dismissBanner } from '../../../redux/dismissableBanner';
import { getCookie, setCookie } from '../../../utils/cookie';

const SetDisplay = ({ visible }) => css`
  display: ${visible ? 'block' : 'none'};
`;

const Container = styled.div`
  font-size: 0.75rem;
  line-height: 1rem;
  margin: 0 1rem;
  ${SetDisplay};
`;

/**
 * DismissableBanner
 *
 * This is a simple, dismissable banner. You may specify a message and a message ID to identify this banner.
 *
 * propTypes
 * @property {any} children The message to display in the box (may contain links).
 * @property {string} messageId The id of the message; must be unique per-message.
 */
export class DismissableBanner extends Component {
  static propTypes = {
    align: PropTypes.string,
    color: PropTypes.string,
    cookieIdentifier: PropTypes.string,
    messageId: PropTypes.string.isRequired,
    strokeColor: PropTypes.string,
    dismissBanner: PropTypes.func,
    dismissable: PropTypes.bool,
    visible: PropTypes.bool,
  };

  static defaultProps = {
    align: 'center',
    color: 'white',
    dismissable: true,
  };

  dismiss = cookieIdentifier => {
    if (typeof document !== 'undefined' && cookieIdentifier) {
      setCookie(cookieIdentifier, true, 30);
    }

    this.props.dismissBanner(this.props.messageId);
  };

  render() {
    const {
      align,
      cookieIdentifier,
      className,
      color,
      children,
      dismissable,
      visible,
      messageId,
      hiddenBanners,
      strokeColor,
    } = this.props;

    if (
      (dismissable && typeof document === 'undefined') ||
      (cookieIdentifier && getCookie(cookieIdentifier))
    ) {
      return null;
    }

    return (
      <Container className={className} visible={visible}>
        {visible ? (
          <CloseBox
            align={align}
            color={color}
            closeable={dismissable}
            strokeColor={strokeColor}
            dismiss={() => this.dismiss(cookieIdentifier)}
            children={children}
          />
        ) : (
          <p>{messageId} has been dismissed</p>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (
  { dismissableBanner: { hiddenBanners } },
  { messageId, visible },
) => ({
  visible:
    typeof visible === 'undefined'
      ? !hiddenBanners.includes(messageId)
      : visible,
});
const mapDispatchToProps = { dismissBanner };

export default connect(mapStateToProps, mapDispatchToProps)(DismissableBanner);
